import sortBy from "lodash.sortby";

export const sortProps = (props) => sortBy(Object.keys(props), (key) => props[key].qid);
